/**
 * i18n minimale per la pagina pubblica /checkin/<token>.
 * 5 lingue: IT EN FR ES DE. Niente librerie extra: dict + funzione t().
 *
 * Per aggiungere una stringa: aggiungerla su tutte e 5 le mappe.
 */

const STRINGS = {
  it: {
    welcome_badge: 'Check-in digitale · GDPR-compliant',
    welcome_title: 'Benvenuto a {property}',
    welcome_subtitle: 'Per legge italiana dobbiamo registrare i tuoi dati con la Polizia di Stato. Ci vogliono 2 minuti.',
    legal_title: 'Cosa stai facendo',
    legal_body: 'Compili la registrazione obbligatoria prevista dall\'Art. 109 del TULPS (R.D. 773/1931). I tuoi dati personali vengono trasmessi alla Polizia di Stato e successivamente cancellati dai nostri server. Conservazione 5 anni: competenza esclusiva del Ministero dell\'Interno. Base giuridica GDPR: Art. 6.1.c (obbligo legale).',
    privacy_no_image: 'La foto del documento NON viene mai uploadata. La scansione avviene direttamente nel tuo browser e l\'immagine viene cancellata appena letta.',
    booking_dates: 'Dal {check_in} al {check_out} · {nights} nott{nights_plural}',
    booking_guests: '{guests_count} ospit{guests_plural} da registrare',
    start_btn: 'Iniziamo',
    guest_step: 'Ospite {n} di {total}',
    capofamiglia_label: 'Capofamiglia',
    familiare_label: 'Familiare',
    singolo_label: 'Ospite singolo',
    scan_doc_title: 'Scansiona il documento',
    scan_doc_subtitle: 'Inquadra la zona MRZ in basso (le righe con i caratteri «<»). Funziona con carta d\'identità (CIE) o passaporto.',
    scan_start: 'Avvia fotocamera',
    scan_stop: 'Ferma',
    scan_capture: 'Scatta e leggi',
    scan_loading: 'Sto leggendo il documento...',
    scan_success: 'Documento riconosciuto!',
    scan_error: 'Non sono riuscito a leggere il barcode. Prova di nuovo o compila a mano.',
    skip_scan: 'Salta scansione · compilo a mano',
    field_cognome: 'Cognome',
    field_nome: 'Nome',
    field_sesso: 'Sesso',
    field_male: 'Maschio',
    field_female: 'Femmina',
    field_birth_date: 'Data di nascita',
    field_birth_place: 'Comune di nascita (codice ISTAT 9 char)',
    field_birth_place_help: 'Esempi: H501 (Roma), F205 (Milano)',
    field_birth_province: 'Provincia di nascita',
    field_birth_province_help: 'Sigla 2 lettere (es. RM, MI, NA)',
    field_birth_state: 'Stato di nascita (codice ISTAT)',
    field_birth_state_help: 'Italia = 100000100. Per altri paesi vedi tabella ISTAT.',
    field_citizenship: 'Cittadinanza (codice ISTAT)',
    field_citizenship_help: 'Italia = 100000100. Auto-rilevato dal documento.',
    field_residence: 'Comune/Stato di residenza',
    field_doc_type: 'Tipo documento',
    field_doc_number: 'Numero documento',
    field_doc_place: 'Luogo di rilascio (codice ISTAT)',
    doc_identita: "Carta d'identità",
    doc_cart_ident_el: "Carta d'identità elettronica (CIE)",
    doc_passaporto: 'Passaporto',
    doc_patente: 'Patente',
    doc_perm_soggiorno: 'Permesso di soggiorno',
    next_btn: 'Avanti',
    submit_btn: 'Conferma e procedi',
    last_submit_btn: 'Conferma · ultima registrazione',
    submitting: 'Invio in corso...',
    success_title: 'Registrazione completata!',
    success_body: 'Tutti gli ospiti sono stati registrati. Buon soggiorno! 🌟',
    success_purge: 'I tuoi dati saranno trasmessi alla Polizia e cancellati dai nostri server.',
    error_invalid: 'Link non valido o scaduto',
    error_expired: 'Check-in già completato e dati cancellati (GDPR)',
    required: 'Campo obbligatorio',
  },

  en: {
    welcome_badge: 'Digital check-in · GDPR-compliant',
    welcome_title: 'Welcome to {property}',
    welcome_subtitle: 'Italian law requires us to register your data with the State Police. It takes 2 minutes.',
    legal_title: 'What you\'re doing',
    legal_body: 'You\'re completing the mandatory registration under Article 109 of TULPS (R.D. 773/1931). Your personal data is transmitted to the State Police and then deleted from our servers. 5-year retention: handled exclusively by the Italian Ministry of Interior. GDPR legal basis: Art. 6.1.c (legal obligation).',
    privacy_no_image: 'Your document photo is NEVER uploaded. The scan happens directly in your browser and the image is deleted as soon as it\'s read.',
    booking_dates: 'From {check_in} to {check_out} · {nights} night{nights_plural}',
    booking_guests: '{guests_count} guest{guests_plural} to register',
    start_btn: 'Let\'s start',
    guest_step: 'Guest {n} of {total}',
    capofamiglia_label: 'Family head',
    familiare_label: 'Family member',
    singolo_label: 'Single guest',
    scan_doc_title: 'Scan the document',
    scan_doc_subtitle: 'Frame the MRZ zone at the bottom (the lines with «<» characters). Works with ID card or passport.',
    scan_start: 'Start camera',
    scan_stop: 'Stop',
    scan_capture: 'Snap and read',
    scan_loading: 'Reading the document...',
    scan_success: 'Document recognized!',
    scan_error: 'Couldn\'t read the barcode. Try again or fill manually.',
    skip_scan: 'Skip scan · fill manually',
    field_cognome: 'Last name',
    field_nome: 'First name',
    field_sesso: 'Sex',
    field_male: 'Male',
    field_female: 'Female',
    field_birth_date: 'Date of birth',
    field_birth_place: 'Birth place (ISTAT 9-char code, only if Italy)',
    field_birth_place_help: 'Examples: H501 (Rome), F205 (Milan).',
    field_birth_province: 'Birth province (only if Italy)',
    field_birth_province_help: '2-letter province sigla (e.g. RM, MI, NA)',
    field_birth_state: 'Country of birth (ISTAT code)',
    field_birth_state_help: 'Italy = 100000100. For other countries see ISTAT table.',
    field_citizenship: 'Citizenship (ISTAT code)',
    field_citizenship_help: 'Italy = 100000100. Auto-detected from document.',
    field_residence: 'Residence (ISTAT code)',
    field_doc_type: 'Document type',
    field_doc_number: 'Document number',
    field_doc_place: 'Place of issue (ISTAT code)',
    doc_identita: 'ID card',
    doc_cart_ident_el: 'Electronic ID card (CIE)',
    doc_passaporto: 'Passport',
    doc_patente: 'Driving license',
    doc_perm_soggiorno: 'Residence permit',
    next_btn: 'Next',
    submit_btn: 'Confirm & proceed',
    last_submit_btn: 'Confirm · final registration',
    submitting: 'Submitting...',
    success_title: 'Registration complete!',
    success_body: 'All guests have been registered. Have a great stay! 🌟',
    success_purge: 'Your data will be transmitted to the Police and deleted from our servers.',
    error_invalid: 'Invalid or expired link',
    error_expired: 'Check-in already completed and data deleted (GDPR)',
    required: 'Required field',
  },

  fr: {
    welcome_badge: 'Enregistrement digital · RGPD',
    welcome_title: 'Bienvenue à {property}',
    welcome_subtitle: 'La loi italienne exige l\'enregistrement de vos données auprès de la Police d\'État. Cela prend 2 minutes.',
    legal_title: 'Ce que vous faites',
    legal_body: 'Vous remplissez l\'enregistrement obligatoire prévu à l\'Article 109 du TULPS (R.D. 773/1931). Vos données personnelles sont transmises à la Police puis supprimées de nos serveurs. Conservation 5 ans : compétence exclusive du Ministère de l\'Intérieur italien. Base juridique RGPD : Art. 6.1.c (obligation légale).',
    privacy_no_image: 'La photo du document n\'est JAMAIS téléchargée. La numérisation a lieu directement dans votre navigateur et l\'image est supprimée dès qu\'elle est lue.',
    booking_dates: 'Du {check_in} au {check_out} · {nights} nuit{nights_plural}',
    booking_guests: '{guests_count} invité{guests_plural} à enregistrer',
    start_btn: 'Commençons',
    guest_step: 'Invité {n} sur {total}',
    capofamiglia_label: 'Chef de famille',
    familiare_label: 'Membre de la famille',
    singolo_label: 'Invité unique',
    scan_doc_title: 'Scannez le document',
    scan_doc_subtitle: 'Cadrez la zone MRZ en bas (les lignes avec «<»). Fonctionne avec carte d\'identité ou passeport.',
    scan_start: 'Activer la caméra',
    scan_stop: 'Arrêter',
    scan_capture: 'Photographier et lire',
    scan_loading: 'Lecture du document...',
    scan_success: 'Document reconnu !',
    scan_error: 'Impossible de lire le code-barres. Réessayez ou remplissez manuellement.',
    skip_scan: 'Sauter le scan · remplir à la main',
    field_cognome: 'Nom',
    field_nome: 'Prénom',
    field_sesso: 'Sexe',
    field_male: 'Homme',
    field_female: 'Femme',
    field_birth_date: 'Date de naissance',
    field_birth_place: 'Lieu de naissance (code ISTAT 9 car., uniquement Italie)',
    field_birth_place_help: 'Exemples : H501 (Rome), F205 (Milan).',
    field_birth_province: 'Province de naissance (uniquement Italie)',
    field_birth_province_help: 'Sigle 2 lettres (ex. RM, MI, NA)',
    field_birth_state: 'Pays de naissance (code ISTAT)',
    field_birth_state_help: 'Italie = 100000100.',
    field_citizenship: 'Nationalité (code ISTAT)',
    field_citizenship_help: 'Italie = 100000100. Auto-détecté.',
    field_residence: 'Lieu de résidence (code ISTAT)',
    field_doc_type: 'Type de document',
    field_doc_number: 'Numéro du document',
    field_doc_place: 'Lieu d\'émission (code ISTAT)',
    doc_identita: 'Carte d\'identité',
    doc_cart_ident_el: 'Carte d\'identité électronique',
    doc_passaporto: 'Passeport',
    doc_patente: 'Permis de conduire',
    doc_perm_soggiorno: 'Permis de séjour',
    next_btn: 'Suivant',
    submit_btn: 'Confirmer et continuer',
    last_submit_btn: 'Confirmer · dernier enregistrement',
    submitting: 'Envoi en cours...',
    success_title: 'Enregistrement terminé !',
    success_body: 'Tous les invités ont été enregistrés. Bon séjour ! 🌟',
    success_purge: 'Vos données seront transmises à la Police et supprimées de nos serveurs.',
    error_invalid: 'Lien invalide ou expiré',
    error_expired: 'Enregistrement déjà terminé, données supprimées (RGPD)',
    required: 'Champ obligatoire',
  },

  es: {
    welcome_badge: 'Check-in digital · GDPR',
    welcome_title: 'Bienvenido a {property}',
    welcome_subtitle: 'La ley italiana nos obliga a registrar tus datos con la Policía. Solo tardarás 2 minutos.',
    legal_title: 'Qué estás haciendo',
    legal_body: 'Estás completando el registro obligatorio previsto en el Artículo 109 del TULPS (R.D. 773/1931). Tus datos se transmiten a la Policía italiana y luego se eliminan de nuestros servidores. Conservación 5 años: competencia exclusiva del Ministerio del Interior italiano. Base jurídica GDPR: Art. 6.1.c (obligación legal).',
    privacy_no_image: 'La foto del documento NUNCA se sube. El escaneo ocurre directamente en tu navegador y la imagen se elimina al instante.',
    booking_dates: 'Del {check_in} al {check_out} · {nights} noche{nights_plural}',
    booking_guests: '{guests_count} huésped{guests_plural} por registrar',
    start_btn: 'Empezamos',
    guest_step: 'Huésped {n} de {total}',
    capofamiglia_label: 'Cabeza de familia',
    familiare_label: 'Familiar',
    singolo_label: 'Huésped individual',
    scan_doc_title: 'Escanea el documento',
    scan_doc_subtitle: 'Encuadra la zona MRZ en la parte inferior (líneas con «<»). Funciona con DNI o pasaporte.',
    scan_start: 'Activar cámara',
    scan_stop: 'Detener',
    scan_capture: 'Capturar y leer',
    scan_loading: 'Leyendo el documento...',
    scan_success: '¡Documento reconocido!',
    scan_error: 'No pude leer el código. Intenta de nuevo o rellena a mano.',
    skip_scan: 'Saltar escaneo · rellenar a mano',
    field_cognome: 'Apellido',
    field_nome: 'Nombre',
    field_sesso: 'Sexo',
    field_male: 'Hombre',
    field_female: 'Mujer',
    field_birth_date: 'Fecha de nacimiento',
    field_birth_place: 'Lugar de nacimiento (código ISTAT 9 car., solo Italia)',
    field_birth_place_help: 'Ejemplos: H501 (Roma), F205 (Milán).',
    field_birth_province: 'Provincia de nacimiento (solo Italia)',
    field_birth_province_help: 'Sigla 2 letras (ej. RM, MI, NA)',
    field_birth_state: 'País de nacimiento (código ISTAT)',
    field_birth_state_help: 'Italia = 100000100.',
    field_citizenship: 'Nacionalidad (código ISTAT)',
    field_citizenship_help: 'Italia = 100000100. Auto-detectado.',
    field_residence: 'Residencia (código ISTAT)',
    field_doc_type: 'Tipo de documento',
    field_doc_number: 'Número de documento',
    field_doc_place: 'Lugar de emisión (código ISTAT)',
    doc_identita: 'DNI/Cédula',
    doc_cart_ident_el: 'DNI electrónico',
    doc_passaporto: 'Pasaporte',
    doc_patente: 'Permiso de conducir',
    doc_perm_soggiorno: 'Permiso de residencia',
    next_btn: 'Siguiente',
    submit_btn: 'Confirmar y continuar',
    last_submit_btn: 'Confirmar · último registro',
    submitting: 'Enviando...',
    success_title: '¡Registro completado!',
    success_body: 'Todos los huéspedes han sido registrados. ¡Buena estancia! 🌟',
    success_purge: 'Tus datos se transmitirán a la Policía y se eliminarán de nuestros servidores.',
    error_invalid: 'Enlace no válido o caducado',
    error_expired: 'Check-in ya completado, datos eliminados (GDPR)',
    required: 'Campo obligatorio',
  },

  de: {
    welcome_badge: 'Digitaler Check-in · DSGVO',
    welcome_title: 'Willkommen bei {property}',
    welcome_subtitle: 'Das italienische Gesetz verpflichtet uns, Ihre Daten bei der Staatspolizei zu registrieren. Es dauert nur 2 Minuten.',
    legal_title: 'Was Sie gerade tun',
    legal_body: 'Sie führen die vorgeschriebene Registrierung gemäß Art. 109 TULPS (R.D. 773/1931) durch. Ihre Daten werden an die italienische Polizei übermittelt und anschließend von unseren Servern gelöscht. 5 Jahre Aufbewahrung: ausschließlich beim italienischen Innenministerium. DSGVO-Rechtsgrundlage: Art. 6.1.c (rechtliche Verpflichtung).',
    privacy_no_image: 'Das Dokumentenfoto wird NIEMALS hochgeladen. Der Scan erfolgt direkt in Ihrem Browser und das Bild wird sofort gelöscht.',
    booking_dates: 'Vom {check_in} bis {check_out} · {nights} Nacht{nights_plural}',
    booking_guests: '{guests_count} Gast{guests_plural} zu registrieren',
    start_btn: 'Los geht\'s',
    guest_step: 'Gast {n} von {total}',
    capofamiglia_label: 'Familienoberhaupt',
    familiare_label: 'Familienmitglied',
    singolo_label: 'Einzelgast',
    scan_doc_title: 'Dokument scannen',
    scan_doc_subtitle: 'Den MRZ-Bereich unten erfassen (Zeilen mit «<»). Funktioniert mit Personalausweis oder Reisepass.',
    scan_start: 'Kamera starten',
    scan_stop: 'Stopp',
    scan_capture: 'Aufnehmen und lesen',
    scan_loading: 'Dokument wird gelesen...',
    scan_success: 'Dokument erkannt!',
    scan_error: 'Code konnte nicht gelesen werden. Erneut versuchen oder manuell ausfüllen.',
    skip_scan: 'Scan überspringen · manuell ausfüllen',
    field_cognome: 'Nachname',
    field_nome: 'Vorname',
    field_sesso: 'Geschlecht',
    field_male: 'Männlich',
    field_female: 'Weiblich',
    field_birth_date: 'Geburtsdatum',
    field_birth_place: 'Geburtsort (ISTAT-Code 9 Zeichen, nur Italien)',
    field_birth_place_help: 'Beispiele: H501 (Rom), F205 (Mailand).',
    field_birth_province: 'Geburtsprovinz (nur Italien)',
    field_birth_province_help: '2-Buchstaben-Sigle (z.B. RM, MI, NA)',
    field_birth_state: 'Geburtsland (ISTAT-Code)',
    field_birth_state_help: 'Italien = 100000100.',
    field_citizenship: 'Staatsangehörigkeit (ISTAT-Code)',
    field_citizenship_help: 'Italien = 100000100. Auto-erkannt.',
    field_residence: 'Wohnsitz (ISTAT-Code)',
    field_doc_type: 'Dokumenttyp',
    field_doc_number: 'Dokumentennummer',
    field_doc_place: 'Ausstellungsort (ISTAT-Code)',
    doc_identita: 'Personalausweis',
    doc_cart_ident_el: 'Elektronischer Ausweis',
    doc_passaporto: 'Reisepass',
    doc_patente: 'Führerschein',
    doc_perm_soggiorno: 'Aufenthaltsgenehmigung',
    next_btn: 'Weiter',
    submit_btn: 'Bestätigen & fortfahren',
    last_submit_btn: 'Bestätigen · letzte Registrierung',
    submitting: 'Wird gesendet...',
    success_title: 'Registrierung abgeschlossen!',
    success_body: 'Alle Gäste wurden registriert. Schönen Aufenthalt! 🌟',
    success_purge: 'Ihre Daten werden an die Polizei übermittelt und von unseren Servern gelöscht.',
    error_invalid: 'Ungültiger oder abgelaufener Link',
    error_expired: 'Check-in bereits abgeschlossen, Daten gelöscht (DSGVO)',
    required: 'Pflichtfeld',
  },
};

export const SUPPORTED_LOCALES = ['it', 'en', 'fr', 'es', 'de'];

export const LOCALE_LABELS = {
  it: 'Italiano',
  en: 'English',
  fr: 'Français',
  es: 'Español',
  de: 'Deutsch',
};

export const LOCALE_FLAGS = {
  it: '🇮🇹',
  en: '🇬🇧',
  fr: '🇫🇷',
  es: '🇪🇸',
  de: '🇩🇪',
};

/** Detect best initial locale from navigator.languages, falling back to 'en'. */
export function detectLocale() {
  if (typeof navigator === 'undefined') return 'en';
  const langs = navigator.languages || [navigator.language || 'en'];
  for (const lang of langs) {
    const code = (lang || '').slice(0, 2).toLowerCase();
    if (SUPPORTED_LOCALES.includes(code)) return code;
  }
  return 'en';
}

/** Translate. Substitutes {placeholder} from `vars`. */
export function t(locale, key, vars = {}) {
  const dict = STRINGS[locale] || STRINGS.en;
  let s = dict[key] || STRINGS.en[key] || key;
  for (const [k, v] of Object.entries(vars)) {
    s = s.replace(new RegExp(`\\{${k}\\}`, 'g'), v);
  }
  return s;
}
